'use strict';

var core = require('datastore-core');

var ShardingStore = core.ShardingDatastore;

var Key = require('interface-datastore').Key;

var base32 = require('base32.js');

var Block = require('ipfs-block');

var setImmediate = require('async/setImmediate');

var reject = require('async/reject');

var CID = require('cids');

var pull = require('pull-stream');
/**
 * Transform a raw buffer to a base32 encoded key.
 *
 * @param {Buffer} rawKey
 * @returns {Key}
 */


var keyFromBuffer = function keyFromBuffer(rawKey) {
  var enc = new base32.Encoder();
  return new Key('/' + enc.write(rawKey).finalize(), false);
};
/**
 * Transform a cid to the appropriate datastore key.
 *
 * @param {CID} cid
 * @returns {Key}
 */


var cidToDsKey = function cidToDsKey(cid) {
  return keyFromBuffer(cid.buffer);
};

module.exports = function (filestore, options, callback) {
  maybeWithSharding(filestore, options, function (err, store) {
    if (err) {
      return callback(err);
    }

    callback(null, createBaseStore(store));
  });
};

function maybeWithSharding(filestore, options, callback) {
  if (options.sharding) {
    var shard = new core.shard.NextToLast(2);
    ShardingStore.createOrOpen(filestore, shard, callback);
  } else {
    setImmediate(function () {
      return callback(null, filestore);
    });
  }
}

function createBaseStore(store) {
  return {
    /**
     * Query the store.
     *
     * @param {object} query
     * @param {function(Error, Array)} callback
     * @return {void}
     */
    query: function query(_query, callback) {
      pull(store.query(_query), pull.collect(callback));
    },

    /**
     * Get a single block by CID.
     *
     * @param {CID} cid
     * @param {function(Error, Block)} callback
     * @returns {void}
     */
    get: function get(cid, callback) {
      if (!CID.isCID(cid)) {
        return setImmediate(function () {
          callback(new Error('Not a valid cid'));
        });
      }

      var k = cidToDsKey(cid);
      store.get(k, function (err, blockData) {
        if (err) {
          return callback(err);
        }

        callback(null, new Block(blockData, cid));
      });
    },
    put: function put(block, callback) {
      if (!Block.isBlock(block)) {
        return setImmediate(function () {
          callback(new Error('invalid block'));
        });
      }

      var k = cidToDsKey(block.cid);
      store.has(k, function (err, exists) {
        if (err) {
          return callback(err);
        }

        if (exists) {
          return callback();
        }

        store.put(k, block.data, callback);
      });
    },

    /**
     * Like put, but for more.
     *
     * @param {Array<Block>} blocks
     * @param {function(Error)} callback
     * @returns {void}
     */
    putMany: function putMany(blocks, callback) {
      var keys = blocks.map(function (b) {
        return {
          key: cidToDsKey(b.cid),
          block: b
        };
      });
      var batch = store.batch();
      reject(keys, function (k, cb) {
        return store.has(k.key, cb);
      }, function (err, newKeys) {
        if (err) {
          return callback(err);
        }

        newKeys.forEach(function (k) {
          batch.put(k.key, k.block.data);
        });
        batch.commit(callback);
      });
    },

    /**
     * Does the store contain block with this cid?
     *
     * @param {CID} cid
     * @param {function(Error, bool)} callback
     * @returns {void}
     */
    has: function has(cid, callback) {
      if (!CID.isCID(cid)) {
        return setImmediate(function () {
          callback(new Error('Not a valid cid'));
        });
      }

      store.has(cidToDsKey(cid), callback);
    },

    /**
     * Delete a block from the store
     *
     * @param {CID} cid
     * @param {function(Error)} callback
     * @returns {void}
     */
    delete: function _delete(cid, callback) {
      if (!CID.isCID(cid)) {
        return setImmediate(function () {
          callback(new Error('Not a valid cid'));
        });
      }

      store.delete(cidToDsKey(cid), callback);
    },
    close: function close(callback) {
      store.close(callback);
    }
  };
}